// ==============================================
// ================Import Actions================
// ==============================================

import { SAVE_STATIONS, SET_CHARGING_NEW_LIST_STATIONS } from '../actions/dataAPI';
import { SET_NEW_LIST } from '../actions/site';
// ==============================================
// ================InitialState==================
// ==============================================

const initialState = {
  stations: {
    list: [],
    newList: [],
    chargingNewList: false,
  },
  data: {
    fullData: [],
  },
};

function dataAPIReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SAVE_STATIONS:
      return {
        ...state,
        stations: {
          ...state.stations,
          list: action.stations,
        },
      };
    case SET_NEW_LIST:
      return {
        ...state,
        stations: {
          ...state.stations,
          newList: action.value,
        },
      };
    case SET_CHARGING_NEW_LIST_STATIONS:
      return {
        ...state,
        stations: {
          ...state.stations,
          chargingNewList: action.value,
        },
      };
    default:
      return state;
  }
}

export default dataAPIReducer;
